









































import Vue from "vue";
import {
  required,
  integer,
  minValue,
  minLength,
  requiredIf
} from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import { Shop } from "../models/Shop";
export default Vue.extend({
  mixins: [dialog],
  validations: {
    shop: { required }
  },
  data() {
    const shop: Shop | {} = {};
    const shops: Shop[] = [];
    const isLoading = false;
    const isShowOverLay = false;
    const isShowDialog = false;
    const token = "";
    return { shops, isLoading, shop, token, isShowOverLay, isShowDialog };
  },
  computed: {
    shopError() {
      return (this as any).$v.shop.$error ? "ร้าน is required" : "";
    }
  },
  async created() {
    this.isLoading = true;
    await Promise.all([this.getShops()]);
    this.isLoading = false;
  },
  methods: {
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error);
      }
    },
    async CreateToken() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.createToken(
          this.shop
        );
        this.token = `register:${data.registerToken}`;
        this.isShowDialog = true;
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.isLoading = true;
      await this.CreateToken();
      this.isLoading = false;
    },
    copyToken() {
      this.isShowDialog = false;
      this.isShowOverLay = true;
      setTimeout(() => {
        this.isShowOverLay = false;
      }, 500);
    }
  }
});
